/**
 * Registro único do service worker de notificações (`/sw.js`).
 *
 * O worker não faz cache de assets de propósito: apenas recebe push e trata o
 * clique. Assim uma atualização do app nunca fica presa em um build antigo.
 */

let registroPromise = null;

const comTimeout = (promise, ms = 10000) =>
  new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), ms);

    promise
      .then((valor) => resolve(valor))
      .catch(() => resolve(null))
      .finally(() => clearTimeout(timer));
  });

export const registrarServiceWorker = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return Promise.resolve(null);
  }

  if (!('serviceWorker' in navigator) || !window.isSecureContext) {
    return Promise.resolve(null);
  }

  if (!registroPromise) {
    registroPromise = navigator.serviceWorker
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .catch((error) => {
        registroPromise = null;
        throw error;
      });
  }

  return registroPromise;
};

export const obterRegistroServiceWorker = async () => {
  const registro = await registrarServiceWorker();

  if (!registro) return null;

  return (await comTimeout(navigator.serviceWorker.ready, 10000)) || registro;
};

/**
 * Inscrição push ativa neste navegador (se existir).
 * Usa apenas um worker já registrado: não cria um novo durante logout/401.
 */
export const obterInscricaoPushLocal = async () => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return null;

  try {
    const registro = await navigator.serviceWorker.getRegistration('/');
    return (await registro?.pushManager?.getSubscription()) || null;
  } catch {
    return null;
  }
};

/** Cancela a inscrição local sem chamar o backend (usado em 401). */
export const limparInscricaoPushLocal = async () => {
  const subscription = await obterInscricaoPushLocal();

  if (!subscription) return;

  try {
    await subscription.unsubscribe();
  } catch {
    // Ignora falhas de navegador.
  }
};

const serviceWorkerUtils = {
  registrarServiceWorker,
  obterRegistroServiceWorker,
  obterInscricaoPushLocal,
  limparInscricaoPushLocal,
};

export default serviceWorkerUtils;
